import React, { useEffect, useState } from 'react';
import header from '../../assets/images/Ijtimai.png';

export default function FinalSlip() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Supplier ka saved data read karne ke liye key local storage se check karein
    const savedData = localStorage.getItem('temp_supplier_final_slip');
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        const finalData = Array.isArray(parsed) ? parsed : (parsed.details || [parsed]);
        setData(finalData);
      } catch (e) {
        console.error("Data parse error:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      const timer = setTimeout(() => {
        window.print();
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [data]);

  if (!data) return <div style={{ padding: '50px', textAlign: 'center' }}>Loading Statement...</div>;

  // F&F Calculations (Array ke pehle object se defaults map ho rahay hain)
  const grossDealAmount = Number(data[0]?.deposit || data[0]?.total_amt || 0); 
  const previousAdvances = Number(data[0]?.total_paid || data[0]?.advance || 0); 
  const currentDisbursement = Number(data[0]?.pay_amount || 0); 
  const remainingBalance = grossDealAmount - (previousAdvances + currentDisbursement);

  return (
    <div className="printable-area">
      <style>{`
        @media screen {
          body { background: #f1f5f9; margin: 0; padding: 20px; }
          .printable-area { 
            background: white; width: 210mm; margin: auto; padding: 40px; 
            box-shadow: 0 0 10px rgba(0,0,0,0.1); min-height: 297mm;
          }
        }

        @media print {
          body * { visibility: hidden !important; }
          .printable-area, .printable-area * { visibility: visible !important; }
          .printable-area { 
            position: absolute !important; left: 0; top: 0; width: 100% !important; 
            margin: 0 !important; padding: 10mm !important; display: block !important;
          }
          @page { size: A4; margin: 0; }
        }

        /* Consistent Font Sizes and Layout from Butcher Slip */
        .printable-area { font-family: sans-serif; color: #000; line-height: 1.8; }
        .slip-header { text-align: center; border-bottom: 2px solid #000; margin-bottom: 15px; }
        .header-img { width: 100%; max-height: 100px; object-fit: contain; }
        
        .info-row { border: 1px solid black; display: flex; justify-content: space-between; margin-bottom: 15px; }
        .info-text { font-size: 14px; margin: 20px 10px; }
        
        .data-table { width: 100%; border-collapse: collapse; margin-top: 15px; }
        .data-table th, .data-table td { border: 1px solid #000; padding: 6px; text-align: left; font-size: 11px; }
        .data-table th { background: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
        
        .summary-box { margin-top: 20px; text-align: right; border: 1px solid #000; padding: 20px 10px; }
        .summary-text { font-size: 13px; margin: 2px 0; }
        .net-payable { font-size: 16px; font-weight: bold; margin-top: 5px; }

        .declaration-box { margin-top: 20px; border: 1px dashed #000; padding: 12px; font-size: 11px; text-align: justify; line-height: 1.5; }
        
        .footer-container { margin-top: 50px; }
        .footer-sigs { display: flex; justify-content: space-between; margin-top: 40px; }
        .sig-line { text-align: center; width: 45%; }
        .sig-line p { margin: 0; font-size: 12px; font-weight: bold; }
      `}</style>

      {/* Identical Header Block */}
      <div className="slip-header">
        <img src={header} alt="header" className="header-img" />
        <h2 style={{ fontSize: '20px', fontWeight: '900', margin: '10px 0', textTransform: 'uppercase' }}>
          Full & Final Settlement Statement
        </h2>
      </div>

      {/* Identical Metadata Row */}
      <div className="info-row">
        <div>
          <p className="info-text px-2 py-2"><strong>Doc No :</strong> STMT-{data[0]?.pay_id || '000'}</p>
          <p className="info-text"><strong>Contact :</strong> {data[0]?.contact || 'N/A'}</p>
        </div>
        <div>
          <p className="info-text px-2 py-2"><strong>Name :</strong> {(data[0]?.supp_name || data[0]?.name)?.toUpperCase()}</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <p className="info-text px-2 py-2"><strong>Date:</strong> {new Date().toLocaleDateString('en-GB')}</p>
          <p className="info-text"><strong>CNIC:</strong> {data[0]?.cnic || 'N/A'}</p>
        </div>
      </div>

      {/* Itemized F&F Accounting Ledger Table */}
      <table className="data-table">
        <thead>
          <tr>
            <th style={{ textAlign: 'center', width: '10%' }}>Item</th>
            <th style={{ width: '50%' }}>Description / Transaction Details</th>
            <th style={{ textAlign: 'center', width: '20%' }}>Stock Context</th>
            <th style={{ textAlign: 'right', width: '20%' }}>Amount (PKR)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ textAlign: 'center' }}>1</td>
            <td>Total Approved Contract Value (Gross Procurement Deal)</td>
            <td style={{ textAlign: 'center' }}>{data[0]?.category_name || 'N/A'} ({data[0]?.no_of_animal || '0'} Heads)</td>
            <td style={{ textAlign: 'right' }}>{grossDealAmount.toLocaleString()}</td>
          </tr>
          <tr>
            <td style={{ textAlign: 'center' }}>2</td>
            <td>Previous Intermediary Advance Payments (Cumulative Paid)</td>
            <td style={{ textAlign: 'center', fontWeight: 'bold', color: 'red' }}>Deduction</td>
            <td style={{ textAlign: 'right' }}>- {previousAdvances.toLocaleString()}</td>
          </tr>
          <tr>
            <td style={{ textAlign: 'center' }}>3</td>
            <td><strong>Final Settlement Amount</strong> (Current Disbursement)</td>
            <td style={{ textAlign: 'center', fontWeight: 'bold', color: 'green' }}>Cleared</td>
            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>- {currentDisbursement.toLocaleString()}</td>
          </tr>
        </tbody>
      </table>

      {/* Identical Accounts Summary Box */}
      <div className="summary-box">
        <p className="summary-text font-black pb-2">Gross Contract Value : PKR {grossDealAmount.toLocaleString()}</p>
        <p className="summary-text font-black pb-2">Total Paid Deductions : PKR {(previousAdvances + currentDisbursement).toLocaleString()}</p>
        <p className="net-payable">Net Outstanding Balance : PKR {remainingBalance.toLocaleString()}</p>
      </div>

      {/* Optional Remarks Block */}
      {data[0]?.remarks && (
        <div style={{ marginTop: '15px', border: '1px solid #000', padding: '10px', fontSide: '11px', fontStyle: 'italic' }}>
          <strong>Accounts Remarks:</strong> {data[0].remarks}
        </div>
      )}

      {/* F&F Account Clearance Declaration */}
      <div className="declaration-box">
        <strong>DECLARATION:</strong> I hereby declare and accept that the ledger statements shown above are accurate and fully calculated. Upon receiving the current Final Settlement Amount, my financial accounts for the contracted stock stand closed, and no further dues remain outstanding against the management committee of Alkhidmat Ijtimai Qurbani Jama masjid Quba.
      </div>

      {/* Identical Signature Structure */}
      <div className="footer-container">
        <div className="footer-sigs mb-20" style={{ marginTop: '60px' }}>
          <div className="sig-line"><p>__________________________________________</p><p>Supplier Signature</p></div>
          <div className="sig-line"><p>__________________________________________</p><p>Secretary</p></div>
        </div>
        <div className="footer-sigs" style={{ marginTop: '60px' }}>
          <div className="sig-line"><p>___________________________________________</p><p>Witness # 1</p></div>
          <div className="sig-line"><p>___________________________________________</p><p>Witness # 2</p></div>
        </div>
      </div>
    </div>
  );
}